<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/ActualizarFoto">Actualización de personas</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de personas</span>
          <form id="formPeso" autocomplete="off" @submit.prevent="editar" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
             <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
             <input type="text" name="gafete" id="gafete" placeholder="Clave distintivo" v-on:click=getPersonaData() required>
             <input type="text" name="nombre" id="nombre" placeholder="Nombre del titular"  :value="formEditar.nombre" required>
             <input type="text" name="apellidos" id="apellidos" placeholder="Apellidos del titular" :value="formEditar.apellidos" required>

             <b-form-select v-model="selected2" class="mb-3" hidden="true" required>
                <template v-slot:first>
        <b-form-select-option :value="null" disabled  >-- Selecciona el tipo --</b-form-select-option>
      </template>
      <b-form-select-option value="Introductor">Introductor</b-form-select-option>
      <b-form-select-option value="Cliente">Cliente</b-form-select-option>
      <b-form-select-option value="Proveedor">Proveedor</b-form-select-option>
      <b-form-select-option value="Trabajador de Introductor">Trabajador de Introductor</b-form-select-option>
      <b-form-select-option value="Chofer">Chofer</b-form-select-option>
     
    </b-form-select>

    <input type="text" name="otro" id="otro" :value="formEditar.nombre" placeholder="Otro tipo">
    <input type="text" name="respaldo" id="respaldo" :value="formEditar.respaldo" placeholder="Persona que respalda" required>
    
    <b-form-checkbox-group
      v-model="selected"
      :options="options"
      class="mb-3"
      value-field="item"
      text-field="name"
      disabled-field="notEnabled"
      hidden= true
    ></b-form-checkbox-group>

    <input type="hidden" name="dias" id="dias" placeholder="dias" v-model="selected">
    
    Hora de entrada (00:00 am/pm)<input type="time" name="horaentrada" id="horaentrada" placeholder="Hora de entrada autorizada" :value="formEditar.horaentrada" required>
    Hora de salida (00:00 am/pm)<input type="time" name="horasalida" id="horasalida" placeholder="Hora de salida autorizada" :value="formEditar.horasalida" required>
    <input type="text" name="area" id="area" placeholder="Área autorizada" :value="formEditar.area" required>
    
    <input type="text" name="telefono" id="telefono" placeholder="Teléfono de contacto" :value="formEditar.telefono" required>
    <input type="text" name="comentarios" id="comentarios" :value="formEditar.comentario" placeholder="Comentarios">
        
       <div class="file-field input-field">
                <div class="btn">
                <span>Fotografía</span>
                <input type="file" name="foto">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text" >
                </div>
            </div>      

            <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad> 
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="tipo" id="tipo" :value=selected2>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="seccionForma" id="seccionForma" :value=seccion>
            
<div class="card-action">

                        <input type="submit" value="Actualizar" class="btn btn-outline-success" required >
                           
        </div>
            </form>
       
    <b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajax() >
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     @on-cell-click="onCellClick2"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:350,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">
          
    <span v-if="props.column.field == 'eliminar'">
       <b-button variant="outline-danger">Eliminar</b-button>
    </span>
    
    <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'

import eliminarDecomisos from '../mixins/eliminarDecomisos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'ActualizarFoto',  
  data () {
    return {
        value:null,
      msg: 'Número de arete',
      inventarioCanales:{},
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        serie:'',
        canal:'',
        seccion:'',
        formEditar:{},
        perfil:'',
selected: null,
        options: [
          { item: '2', name: 'Lunes' },
          { item: '3', name: 'Martes' },
          { item: '4', name: 'Miércoles' },
          { item: '5', name: 'Jueves' },
          { item: '6', name: 'Viernes' },
          { item: '7', name: 'Sábado' },
          { item: '1', name: 'Domingo' },
        ],
selected2: null,
selectedCanal:null,
diasautorizados:null,
//Datos del checkbox
      columns:[
        {
          label:'Gafete',
          field:'gafete'
        },
        {
          label:'Id',
          field:'id',
          hidden: true
        },
        {
          label:'Nombre',
          field:'nombre'
        },
        {
          label:'Apellidos',
          field:'apellidos'
        },

        {
          label:'Eliminar',
          field:'eliminar',
        },
      ],
      rows:[

      ],

      
    }
    },
    created(){
      this.usuario()
        this.ajax()
        
    },
  
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  
  methods:{
      setDia(){
          this.dias=selected
      },
      
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                    this.usuariolocal=response.data.email
                    
                })        
        },

    getPersonaData(){
           this.usuario()

            const id = document.getElementById("gafete").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPersonaData.php?token='+ id)
            
                .then(response=>{
                   this.formEditar = response.data
                    this.selected2= this.formEditar.tipo
                    var days= this.formEditar.diasautorizados
                    var ar=days.split('')
                    this.selected= ar
                })        
        },
  onCellClick2(params) {
         if(params.column.field=="eliminar"){   //que sea solo en esas columnas y que se refresque
         this.serie=params.row.serie
         this.canal=params.row.id
         this.seccion=params.row.seccion
         
         swal({
            title:'Seguro que deseas eliminar el registro',
            text:'',
            icon:'warning',
            buttons:true,
            dangerMode:true,
        })
        .then((aceptar)=>{
            if(aceptar){
            const form=params.row.id
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/eliminarRegistroPersona.php?id=' + form)
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                        this.ajax()
         
                      swal('Se registro fue eliminado')
                       //location.reload()
                        //this.$router.push('/inicio')
                    } else {
                        swal('El registro no fue eliminado')
                    }
                })
            }else{
                return false;
            }
        })
         this.ajax()
        
         
         }
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },


    ajax(){
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     this.getId()
    const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPersonas.php?unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },

    
    usuario(){
       // this.fecha()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     //this.usuariolocal= result
     //const tok=this.usuariolocal
     const tok=result
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    editar(){
        document.getElementById('formPeso').empty
        this.getId()
        
           
            this.usuario()
            
             const form=document.getElementById('formPeso')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/editarPersona.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    if (res.data == 'success') {
                       // this.ticketIncremento()
                      
                       swal('Se registro la persona con éxito'+res.data)
                       //location.reload()
                        //this.$router.push('/inicio')
                        
                    } else {
                        swal('La persona no pudo ser registrado'+res.data)
                    }
                })
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
    components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarDecomisos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ActualizarFoto.vue